import {cloneDeep} from 'lodash';
import * as React from 'react';

import {ICoverImage, IDocument, ITagline, IUserData} from '../../../../infrastructure/interfaces';
import {taglinesForDocument} from '../../../../infrastructure/Taglines';
import {coverImagesForDocument} from '../../../../infrastructure/CoverImageTypes';
import CoverImageEditorForm from '../../../DocumentEditor/CoverImageEditorForm';
import SettingsNav from './SettingsNav';

export interface ICoverImageEditorProps {
  document: IDocument;
  taglines: ITagline[];
  coverImages: ICoverImage[];
  userData: IUserData;
  saveDocument(document: IDocument, userID: string, redirect?: string): void;
  updateModelDocument(document: IDocument): void;
  cancelDocument(): void;
}

export interface ICoverImageEditorState {
  document: IDocument;
}


export default class CoverImageEditor extends React.Component<ICoverImageEditorProps, ICoverImageEditorState> {
  contentNode: Element;
  constructor(props: ICoverImageEditorProps) {
    super(props);
    this.state = {
      document: cloneDeep(props.document),
    };
  }

  componentWillUnmount() {
    if (this.props.updateModelDocument) {
      this.contentNode.parentElement!.scrollTop = 0;
      this.props.updateModelDocument(this.state.document);
    }
  }

  componentWillReceiveProps(nextProps: ICoverImageEditorProps) {
    if (nextProps.document !== this.props.document) {
      this.setState({ document: cloneDeep(nextProps.document) });
    }
  }

  onCoverImageChange = (coverImage: ICoverImage) => {
    // Cover images dictate which taglines are valid. Don't leave an invalid tagline.
    const docWithNewCoverImage = {
      ...this.state.document,
      coverImage,
    }
    const validTaglines = taglinesForDocument(this.props.taglines, docWithNewCoverImage);
    const isTaglineIncluded = validTaglines.find(tagline => tagline.title == docWithNewCoverImage.title) !== undefined;
    const fallbackTaglineTitle = (validTaglines.length > 0) ? validTaglines[0].title : "";
    let newTitle = isTaglineIncluded ? docWithNewCoverImage.title : fallbackTaglineTitle;

    this.setState({
      document: {
        ...this.state.document,
        coverImage,
        title: newTitle
      },
    });
  }

  cancel = () => {
    this.setState({ document: cloneDeep(this.props.document) });
    if (this.props.cancelDocument) {
      this.props.cancelDocument();
    }
  }

  onSave = () => {
    this.props.saveDocument(this.state.document, this.props.userData.id);
  }

  render() {
    return (
      <div className="cropsEditorContainer" ref={(node) => { this.contentNode = node!; }}>
        <SettingsNav
          cancel={this.cancel}
          document={this.state.document}
          onSave={this.onSave}
        />
        <div className="">
          <div className="cropsContainerTitle">
            Select cover background image:
        </div>
        </div>
        <CoverImageEditorForm
          document={this.state.document}
          coverImages={coverImagesForDocument(this.props.coverImages, this.props.document)}
          onCoverImageChange={this.onCoverImageChange}
          className="settingsCropsListContainer"
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/Settings/CoverImageEditor.tsx